import styled from "@emotion/styled";
import { MDSText } from "@/mds";
import { MDSPanelWidths } from "@/mds/foundations";

export const StyledWrapper = styled.header`
  display: flex;
  align-items: flex-end;
  gap: ${({ theme }) => theme.spacing["2"]};
  padding-top: ${({ theme }) => theme.spacing["3"]};
  padding-left: ${({ theme }) => theme.spacing["6"]};
  padding-right: ${({ theme }) => theme.spacing["5"]};
  user-select: none;
  cursor: pointer;

  @container mds-panel (max-width: ${MDSPanelWidths.narrow}px) {
    padding-inline: ${({ theme }) => theme.spacing["2"]};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.border.emphasis};
    outline-offset: 2px;
    border-radius: ${({ theme }) => theme.borderRadius.small};
  }
`;

export const StyledPrimaryText = styled(MDSText)`
  letter-spacing: 0.24px;
  text-transform: uppercase;
  flex: 1;
  min-width: 0;
`;

export const StyledRightAddonContainer = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: auto;
`;

export const StyledTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["0.5"]};
  padding-bottom: ${({ theme }) => theme.spacing["2"]};
`;
